/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The StudentMetaFormativeActions model module.
 * @module model/StudentMetaFormativeActions
 * @version 1.0.0
 */
class StudentMetaFormativeActions {
    /**
     * Constructs a new <code>StudentMetaFormativeActions</code>.
     * @alias module:model/StudentMetaFormativeActions
     */
    constructor() { 
        
        StudentMetaFormativeActions.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>StudentMetaFormativeActions</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/StudentMetaFormativeActions} obj Optional instance to populate.
     * @return {module:model/StudentMetaFormativeActions} The populated <code>StudentMetaFormativeActions</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new StudentMetaFormativeActions();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('course_level')) {
                obj['course_level'] = ApiClient.convertToType(data['course_level'], 'String');
            }
            if (data.hasOwnProperty('shop_code')) {
                obj['shop_code'] = ApiClient.convertToType(data['shop_code'], 'String');
            }
            if (data.hasOwnProperty('is_enrollable')) {
                obj['is_enrollable'] = ApiClient.convertToType(data['is_enrollable'], 'Boolean');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
StudentMetaFormativeActions.prototype['id'] = undefined;

/**
 * @member {String} course_level
 */
StudentMetaFormativeActions.prototype['course_level'] = undefined;

/**
 * @member {String} shop_code
 */
StudentMetaFormativeActions.prototype['shop_code'] = undefined;

/**
 * @member {Boolean} is_enrollable
 */
StudentMetaFormativeActions.prototype['is_enrollable'] = undefined;






export default StudentMetaFormativeActions;

